import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

const ignoredSentryErrors = [/Expiration Time \(exp\) claim error in the access token/, "ResizeObserver loop limit exceeded", "ResizeObserver loop completed with undelivered notifications.", "Non-Error exception captured", "Non-Error promise rejection captured with value"];
const getVersionOverrideTags = function () {
  let componentVersions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.entries(componentVersions).reduce((acc, _ref) => {
    let [webComponent, version] = _ref;
    return {
      ...acc,
      [`versionOverride.${webComponent}`]: version
    };
  }, {});
};
const useSentrySetup = overrides => {
  // Setup sentry
  useEffect(() => {
    const dsn = process.env.IZ_APP_SENTRY_DSN;
    const isCorrectEnv = process.env.APP_ENV !== "development" && process.env.NODE_ENV !== "test";
    const hasDsn = dsn != null;
    const isBrowserSupported = USERAGENT_REGEXP.test(navigator.userAgent);
    if (isCorrectEnv) {
      if (!hasDsn) {
        // eslint-disable-next-line no-console
        console.warn(`Tried to enable sentry but got no DSN. (env: ${process.env.APP_ENV})`);
      }
      if (!isBrowserSupported) {
        // eslint-disable-next-line no-console
        console.warn(`Disabling error reporting due to browser not being supported.`);
      }
    }
    Sentry.init({
      enabled: overrides?.enabled || isCorrectEnv && hasDsn && isBrowserSupported,
      dsn,
      environment: process.env.APP_ENV,
      release: process.env.GIT_SHA,
      integrations: [new Integrations.BrowserTracing()],
      ignoreErrors: [...ignoredSentryErrors, ...(overrides?.ignoreErrors ?? [])]
    });
  }, []);
  const setSentryData = _ref2 => {
    let {
      user,
      config
    } = _ref2;
    Sentry.setUser({
      id: user.organization.fullOrganizationUuid
    });
    Sentry.setTags({
      language: user.locale.language,
      country: user.locale.country,
      currency: user.locale.currency,
      isMobileApp: user.isMobileApp,
      customerStatus: user.organization.customerStatus,
      identityProvider: user.identityProvider,
      businessIdentityProvider: user.businessIdentityProvider,
      ...getVersionOverrideTags(config.componentVersions)
    });
    Sentry.setExtra("betaFeatures", user.organization.betaFeatures);
  };
  return {
    setSentryData
  };
};

export { useSentrySetup };
//# sourceMappingURL=use-sentry-setup.js.map
